const OPEN_TOKEN = /@(\w*)$/

export const hasOpenToken = (textBeforeCaret: string): boolean => OPEN_TOKEN.test(textBeforeCaret)

// rc-mentions runs our onKeyDown before it handles Enter, and only picks when an option matches.
export const hasMatchingMention = (textBeforeCaret: string, handles: string[]): boolean => {
  const token = OPEN_TOKEN.exec(textBeforeCaret)?.[1]
  if (token === undefined) return false
  return handles.some((h) => h.toLowerCase().startsWith(token.toLowerCase()))
}
